import { api, startLoading, endLoading } from '@/api'
import * as types from './types'

export default {
  /**
   * Reset building values to its defaults
   */
  resetBuildingValues ({ commit }) {
    commit(types.RESET_BUILDING)
  },
  /**
  /**
  * Get building by id
  * @param {Number} buildingID - Building ID
  */
  async getBuilding ({ commit, dispatch }, buildingID) {
    let loaderName = 'getBuilding'
    startLoading(dispatch, loaderName)
    return new Promise((resolve, reject) => {
      api
        .getBuilding(buildingID)
        .then((response) => {
          commit(types.SET_BUILDING, response.data)
          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Get all buildings
  * @param {Number} locationID - Location ID
  */
  async getBuildingsByLocation ({ commit, dispatch }, params) {
    let loaderName = 'getBuildingsByLocation'
    startLoading(dispatch, loaderName)

    // Note: We are reusing this action to populate tables AND dropdowns.
    // Below, we check if the parameter sent was a number, meaning that a locationID was sent over.
    let locationID = null
    if (typeof params === 'number') {
      locationID = params
      params = null
    }

    return new Promise((resolve, reject) => {
      api
        .getBuildingsByLocation(params, locationID)
        .then((response) => {
          commit(types.SET_BUILDINGS, response.data.items)
          endLoading(dispatch, loaderName)
          resolve(response.data.count)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Create a new building
  * @param {Object} building - Building's data
  */
  async createBuilding ({ commit, state, dispatch }) {
    let loaderName = 'createBuilding'
    startLoading(dispatch, loaderName)
    return new Promise((resolve, reject) => {
      api
        .createBuilding(state.building)
        .then((response) => {
          // Note: If there's no data, it means that the building already exists
          if (response.data === -1) {
            reject(new Error('The group selected already has five (5) buildings assigned to it.'))
          } else if (response.data !== '') {
            commit(types.ADD_BUILDING, response.data)
            resolve(response)
          } else {
            reject(new Error('Building already exists.'))
          }
          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Update a new building
  * @param {Object} building - Building's data
  */
  async updateBuilding ({ commit, state, dispatch }) {
    let loaderName = 'updateBuilding'
    startLoading(dispatch, loaderName)
    return new Promise((resolve, reject) => {
      api
        .updateBuilding(state.building)
        .then((response) => {
          if (response.data === -1) {
            reject(new Error('Building name already exists.'))
          }
          resolve(response)
          endLoading(dispatch, loaderName)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Delete existing building
  */
  async deleteBuilding ({ commit, dispatch }, building) {
    let loaderName = 'deleteBuilding'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .deleteBuilding({ id: building.id })
        .then((response) => {
          commit(types.DELETE_BUILDING, building)
          endLoading(dispatch, loaderName)
          resolve(response)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Get chart data by building
  * @param {Number} buildingId - Building ID
  */
  async getChartDataByBuilding ({ commit, dispatch }, buildingId) {
    let loaderName = 'getChartDataByBuilding'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .getChartDataByBuilding(buildingId)
        .then((response) => {
          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/building/actions.js